/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CashAccountSource,
  GetPortfolioListResponse,
  PortfolioCashAccountBatchRequest,
  PortfolioCreateRequest,
  PortfolioDetails,
  PortfolioRulesResponse,
  PortfolioUpdateRequest,
  RevisionHistoryResponse,
  SequenceNumbersForBrResponse,
} from '../models/index';
import {
    CashAccountSourceFromJSON,
    CashAccountSourceToJSON,
    GetPortfolioListResponseFromJSON,
    GetPortfolioListResponseToJSON,
    PortfolioCashAccountBatchRequestFromJSON,
    PortfolioCashAccountBatchRequestToJSON,
    PortfolioCreateRequestFromJSON,
    PortfolioCreateRequestToJSON,
    PortfolioDetailsFromJSON,
    PortfolioDetailsToJSON,
    PortfolioRulesResponseFromJSON,
    PortfolioRulesResponseToJSON,
    PortfolioUpdateRequestFromJSON,
    PortfolioUpdateRequestToJSON,
    RevisionHistoryResponseFromJSON,
    RevisionHistoryResponseToJSON,
    SequenceNumbersForBrResponseFromJSON,
    SequenceNumbersForBrResponseToJSON,
} from '../models/index';

export interface BatchCreatePortfolioCashAccountsRequest {
    portfolioUid: string;
    portfolioCashAccountBatchRequest: PortfolioCashAccountBatchRequest;
}

export interface BatchUpdatePortfolioCashAccountsRequest {
    portfolioUid: string;
    portfolioCashAccountBatchRequest: PortfolioCashAccountBatchRequest;
}

export interface CreatePortfolioRequest {
    portfolioCreateRequest: PortfolioCreateRequest;
}

export interface GetPortfolioByPortfolioIdRequest {
    portfolioUid: string;
    brUid: string;
    cashAccountSource?: CashAccountSource;
}

export interface GetPortfolioByServiceAgreementIdRequest {
    serviceAgreementId: string;
    cashAccountSource?: CashAccountSource;
}

export interface GetPortfolioHistoryRequest {
    portfolioUid: string;
}

export interface GetPortfolioRulesForBrRequest {
    brUid: string;
}

export interface GetPortfoliosByBusinessRelationshipIdRequest {
    brUid: string;
    cashAccountSource?: CashAccountSource;
}

export interface GetSequenceNumbersForBrRequest {
    brUid: string;
    accountType: string;
}

export interface UpdatePortfolioRequest {
    portfolioUid: string;
    portfolioUpdateRequest: PortfolioUpdateRequest;
}

/**
 * 
 */
export class PortfolioApi extends runtime.BaseAPI {

    /**
     * Creates request options for batchCreatePortfolioCashAccounts without sending the request
     */
    async batchCreatePortfolioCashAccountsRequestOpts(requestParameters: BatchCreatePortfolioCashAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioUid'] == null) {
            throw new runtime.RequiredError(
                'portfolioUid',
                'Required parameter "portfolioUid" was null or undefined when calling batchCreatePortfolioCashAccounts().'
            );
        }

        if (requestParameters['portfolioCashAccountBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioCashAccountBatchRequest',
                'Required parameter "portfolioCashAccountBatchRequest" was null or undefined when calling batchCreatePortfolioCashAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portfolio/{portfolioUid}/cash-accounts/batch-create`;
        urlPath = urlPath.replace(`{${"portfolioUid"}}`, encodeURIComponent(String(requestParameters['portfolioUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioCashAccountBatchRequestToJSON(requestParameters['portfolioCashAccountBatchRequest']),
        };
    }

    /**
     * Batch-create cash accounts on an existing portfolio
     */
    async batchCreatePortfolioCashAccountsRaw(requestParameters: BatchCreatePortfolioCashAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDetails>> {
        const requestOptions = await this.batchCreatePortfolioCashAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDetailsFromJSON(jsonValue));
    }

    /**
     * Batch-create cash accounts on an existing portfolio
     */
    async batchCreatePortfolioCashAccounts(requestParameters: BatchCreatePortfolioCashAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDetails> {
        const response = await this.batchCreatePortfolioCashAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for batchUpdatePortfolioCashAccounts without sending the request
     */
    async batchUpdatePortfolioCashAccountsRequestOpts(requestParameters: BatchUpdatePortfolioCashAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioUid'] == null) {
            throw new runtime.RequiredError(
                'portfolioUid',
                'Required parameter "portfolioUid" was null or undefined when calling batchUpdatePortfolioCashAccounts().'
            );
        }

        if (requestParameters['portfolioCashAccountBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioCashAccountBatchRequest',
                'Required parameter "portfolioCashAccountBatchRequest" was null or undefined when calling batchUpdatePortfolioCashAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portfolio/{portfolioUid}/cash-accounts/batch-update`;
        urlPath = urlPath.replace(`{${"portfolioUid"}}`, encodeURIComponent(String(requestParameters['portfolioUid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioCashAccountBatchRequestToJSON(requestParameters['portfolioCashAccountBatchRequest']),
        };
    }

    /**
     * Batch-update existing cash accounts on a portfolio (matched by cashAccountId)
     */
    async batchUpdatePortfolioCashAccountsRaw(requestParameters: BatchUpdatePortfolioCashAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDetails>> {
        const requestOptions = await this.batchUpdatePortfolioCashAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDetailsFromJSON(jsonValue));
    }

    /**
     * Batch-update existing cash accounts on a portfolio (matched by cashAccountId)
     */
    async batchUpdatePortfolioCashAccounts(requestParameters: BatchUpdatePortfolioCashAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDetails> {
        const response = await this.batchUpdatePortfolioCashAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPortfolio without sending the request
     */
    async createPortfolioRequestOpts(requestParameters: CreatePortfolioRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioCreateRequest',
                'Required parameter "portfolioCreateRequest" was null or undefined when calling createPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portfolio/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioCreateRequestToJSON(requestParameters['portfolioCreateRequest']),
        };
    }

    /**
     * Create portfolio with nested cash accounts
     */
    async createPortfolioRaw(requestParameters: CreatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDetails>> {
        const requestOptions = await this.createPortfolioRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDetailsFromJSON(jsonValue));
    }

    /**
     * Create portfolio with nested cash accounts
     */
    async createPortfolio(requestParameters: CreatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDetails> {
        const response = await this.createPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfolioByPortfolioId without sending the request
     */
    async getPortfolioByPortfolioIdRequestOpts(requestParameters: GetPortfolioByPortfolioIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioUid'] == null) {
            throw new runtime.RequiredError(
                'portfolioUid',
                'Required parameter "portfolioUid" was null or undefined when calling getPortfolioByPortfolioId().'
            );
        }

        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getPortfolioByPortfolioId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['brUid'] != null) {
            queryParameters['brUid'] = requestParameters['brUid'];
        }

        if (requestParameters['cashAccountSource'] != null) {
            queryParameters['cashAccountSource'] = requestParameters['cashAccountSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portfolio/{portfolioUid}`;
        urlPath = urlPath.replace(`{${"portfolioUid"}}`, encodeURIComponent(String(requestParameters['portfolioUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get portfolio by portfolio id
     */
    async getPortfolioByPortfolioIdRaw(requestParameters: GetPortfolioByPortfolioIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDetails>> {
        const requestOptions = await this.getPortfolioByPortfolioIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDetailsFromJSON(jsonValue));
    }

    /**
     * Get portfolio by portfolio id
     */
    async getPortfolioByPortfolioId(requestParameters: GetPortfolioByPortfolioIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDetails> {
        const response = await this.getPortfolioByPortfolioIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfolioByServiceAgreementId without sending the request
     */
    async getPortfolioByServiceAgreementIdRequestOpts(requestParameters: GetPortfolioByServiceAgreementIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementId'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementId',
                'Required parameter "serviceAgreementId" was null or undefined when calling getPortfolioByServiceAgreementId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cashAccountSource'] != null) {
            queryParameters['cashAccountSource'] = requestParameters['cashAccountSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portfolio/service-agreement/{serviceAgreementId}`;
        urlPath = urlPath.replace(`{${"serviceAgreementId"}}`, encodeURIComponent(String(requestParameters['serviceAgreementId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search portfolio by service agreement id
     */
    async getPortfolioByServiceAgreementIdRaw(requestParameters: GetPortfolioByServiceAgreementIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDetails>> {
        const requestOptions = await this.getPortfolioByServiceAgreementIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDetailsFromJSON(jsonValue));
    }

    /**
     * Search portfolio by service agreement id
     */
    async getPortfolioByServiceAgreementId(requestParameters: GetPortfolioByServiceAgreementIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDetails> {
        const response = await this.getPortfolioByServiceAgreementIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfolioHistory without sending the request
     */
    async getPortfolioHistoryRequestOpts(requestParameters: GetPortfolioHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioUid'] == null) {
            throw new runtime.RequiredError(
                'portfolioUid',
                'Required parameter "portfolioUid" was null or undefined when calling getPortfolioHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portfolio/{portfolioUid}/history`;
        urlPath = urlPath.replace(`{${"portfolioUid"}}`, encodeURIComponent(String(requestParameters['portfolioUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the status change history for a given portfolio. Used to populate the Portfolio Review table on the UI. 
     * Get portfolio review history
     */
    async getPortfolioHistoryRaw(requestParameters: GetPortfolioHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RevisionHistoryResponse>> {
        const requestOptions = await this.getPortfolioHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RevisionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Returns the status change history for a given portfolio. Used to populate the Portfolio Review table on the UI. 
     * Get portfolio review history
     */
    async getPortfolioHistory(requestParameters: GetPortfolioHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RevisionHistoryResponse> {
        const response = await this.getPortfolioHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfolioRulesForBr without sending the request
     */
    async getPortfolioRulesForBrRequestOpts(requestParameters: GetPortfolioRulesForBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getPortfolioRulesForBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portfolio/br/{brUid}/rules`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the portfolio types the business relationship may hold and, per portfolio type, how each create-dialog field behaves. An empty portfolioTypes list means no portfolio is allowed. Guidance for the UI only; 
     * Get allowed portfolio types and field rules for a business relationship
     */
    async getPortfolioRulesForBrRaw(requestParameters: GetPortfolioRulesForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioRulesResponse>> {
        const requestOptions = await this.getPortfolioRulesForBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioRulesResponseFromJSON(jsonValue));
    }

    /**
     * Returns the portfolio types the business relationship may hold and, per portfolio type, how each create-dialog field behaves. An empty portfolioTypes list means no portfolio is allowed. Guidance for the UI only; 
     * Get allowed portfolio types and field rules for a business relationship
     */
    async getPortfolioRulesForBr(requestParameters: GetPortfolioRulesForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioRulesResponse> {
        const response = await this.getPortfolioRulesForBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfoliosByBusinessRelationshipId without sending the request
     */
    async getPortfoliosByBusinessRelationshipIdRequestOpts(requestParameters: GetPortfoliosByBusinessRelationshipIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getPortfoliosByBusinessRelationshipId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cashAccountSource'] != null) {
            queryParameters['cashAccountSource'] = requestParameters['cashAccountSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portfolio/br/{brUid}`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search portfolios by business relationship id
     */
    async getPortfoliosByBusinessRelationshipIdRaw(requestParameters: GetPortfoliosByBusinessRelationshipIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPortfolioListResponse>> {
        const requestOptions = await this.getPortfoliosByBusinessRelationshipIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPortfolioListResponseFromJSON(jsonValue));
    }

    /**
     * Search portfolios by business relationship id
     */
    async getPortfoliosByBusinessRelationshipId(requestParameters: GetPortfoliosByBusinessRelationshipIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPortfolioListResponse> {
        const response = await this.getPortfoliosByBusinessRelationshipIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSequenceNumbersForBr without sending the request
     */
    async getSequenceNumbersForBrRequestOpts(requestParameters: GetSequenceNumbersForBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getSequenceNumbersForBr().'
            );
        }

        if (requestParameters['accountType'] == null) {
            throw new runtime.RequiredError(
                'accountType',
                'Required parameter "accountType" was null or undefined when calling getSequenceNumbersForBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portfolio/sequence-numbers/{brUid}/{accountType}`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));
        urlPath = urlPath.replace(`{${"accountType"}}`, encodeURIComponent(String(requestParameters['accountType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSequenceNumbersForBrRaw(requestParameters: GetSequenceNumbersForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SequenceNumbersForBrResponse>> {
        const requestOptions = await this.getSequenceNumbersForBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SequenceNumbersForBrResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSequenceNumbersForBr(requestParameters: GetSequenceNumbersForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SequenceNumbersForBrResponse> {
        const response = await this.getSequenceNumbersForBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePortfolio without sending the request
     */
    async updatePortfolioRequestOpts(requestParameters: UpdatePortfolioRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioUid'] == null) {
            throw new runtime.RequiredError(
                'portfolioUid',
                'Required parameter "portfolioUid" was null or undefined when calling updatePortfolio().'
            );
        }

        if (requestParameters['portfolioUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioUpdateRequest',
                'Required parameter "portfolioUpdateRequest" was null or undefined when calling updatePortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portfolio/{portfolioUid}`;
        urlPath = urlPath.replace(`{${"portfolioUid"}}`, encodeURIComponent(String(requestParameters['portfolioUid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioUpdateRequestToJSON(requestParameters['portfolioUpdateRequest']),
        };
    }

    /**
     * Update an existing portfolio with nested cash accounts
     */
    async updatePortfolioRaw(requestParameters: UpdatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDetails>> {
        const requestOptions = await this.updatePortfolioRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDetailsFromJSON(jsonValue));
    }

    /**
     * Update an existing portfolio with nested cash accounts
     */
    async updatePortfolio(requestParameters: UpdatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDetails> {
        const response = await this.updatePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
